<template src="./component.html"></template>

<script>
import axios from 'axios';
import {debounce} from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import {scrollTo} from '@/directives/scrollTo';
import {getPrices} from '@/functions/tariffsPrices.js';
import {validateInn} from '@/functions/validate.js';
import {VSlider} from 'vuetify/lib';
// import {dialogSBP} from '@/components/dialogSBP/component';
// import dialogSBP from '@/components/dialogSBP/component';
import Fancybox from '../fancybox.vue';

export default {
  name: 'Calc2',
  props: ['fn', 'fnIndex', 'emitKktCount', 'kktIndex','tariffProp', 'pricesProp'],
  components: {
    Fancybox,
  },
  data() {
    return {
      scene: 'init',
      // scene: 'Sbrf',
      kktCount: 1,
      fnType: 'FN15',
      selectedTariffLine: null,
      rules: {
        required: value => !!value || 'Обязательное поле',
        // eslint-disable-next-line
        email: value => /^[0-9a-z-_а-яА-ЯёЁ\.]+\@[0-9a-z-а-яА-ЯёЁ]{2,}\.[a-zа-яА-ЯёЁ]{2,}/i.test(value) || 'Неверный формат E-Mail',
        inn: value => {
          const validateInnResult = validateInn(value, {});
          return validateInnResult || 'Введён неверный ИНН';
        },
      },
      totalPrice: 0,

      Email: '',
      Inn: '',

      checkBoxAree: false,
      checkBoxPers: false,
      dadataRes: null,

      SmsCount: '',
      SmsCountMore: '',
      BrandingCount: '',
      OrgName: '',
      Kpp: '',
      Ogrn: '',
      isIndividualEntrepreneur: false,

      paymentType: 'Bill',
      PaymentInfo: null,
      OrderData: null,
      Password: '',
      payInProgress: false,
      loginInProgress: false,
      codes: null,
      codesInProgress: false,

      tariffsPrices: getPrices(),

      snackbarOpened: false,
      snackbarText: '',
      priceInProgress: false,

      innInvalid: false,
      innErrors: [],

      tariffLines: [],
      tariffLinesByMnemo: {},
      activeTariffPlanByLineMnemo: {
        // Receipt: {
        // price: null,
        // unitsCnt: null,
        // pricePerUnit: null,
        // }
      },

      fn15Price: null,
      fn36Price: null,

      initPricesLoaded: true,

      priceAxiosAbortController: null,

      modalSBP: false,
      // modalSBP: true,
      QR: '',
      stepModal: 'Registered',
      // stepModal: 'Error',
    }
  },
  watch: {
    fn: function (fn) {
      if (this.fnType !== fn) {
        this.fnType = fn;
        this.calcPrice();
      }
    },
    fnIndex: function () {
      if (this.fnType !== this.fn) {
        this.fnType = this.fn;
        this.calcPrice();
      }
    },
    emitKktCount: function (count) {
      if (this.kktCount != count) {
        this.kktCount = count;
        this.calcPrice();
      }
    },
    kktIndex: function () {
      if (this.kktCount != this.emitKktCount) {
        this.kktCount = this.emitKktCount;
        this.calcPrice();
      }
    },
    kktCount: function () {
      this.tariffsPrices = getPrices(this.kktCount);
    },
  },
  created: function () {
    window.sberbankSuccessPay = () => {
      this.scene = 'pay_success';
      scrollTo('calc');
    }

    window.sberbankFailurePay = () => {
      this.snackbarText = 'При оплате произошла ошибка';
      this.snackbarOpened = true;
      this.scene = 'init';
      scrollTo('calc');
    }

    setTimeout(() => {
      this.calcPrice();
    }, 1000);

    axios.get('https://static.ofd.ru/landing/prices/russtandart.json').then((res) => {
      this.tariffLines = res.data.tariffLines;
      res.data.tariffLines.forEach(tariffLine => {
        this.tariffLinesByMnemo[tariffLine.mnemo] = tariffLine;
        this.activeTariffPlanByLineMnemo[tariffLine.mnemo] = cloneDeep(tariffLine.tariffs[0]);
      });

      if (this.activeTariffPlanByLineMnemo['Receipt']) {
        this.selectedTariffLine = 'Receipt';
      } else {
        this.selectedTariffLine = this.tariffLines[0].mnemo;
      }

      this.fn15Price = res.data.fnPrices.fn15;
      this.fn36Price = res.data.fnPrices.fn36;

      this.initPricesLoaded = true;
    }).catch((err) => {
      this.apiErrHandler(err);
    });
  },
  methods: {
    closeModalSBP () {
      this.modalSBP = false;
    },
    onlyNumber: function (e) {
      var txt = String.fromCharCode(e.which);
      switch (txt) {
        case '-':
        case '+':
          e.preventDefault();
          break;
      }
    },
    changePaymentMethod: function (paymentMethod) {
      this.paymentType = paymentMethod;
    },
    onFn15: function () {
      this.fnType = 'FN15';
      this.calcPrice();
    },
    onFn36: function () {
      this.fnType = 'FN36';
      this.calcPrice();
    },
    onInputKktCount: debounce(function () {
      this.calcPrice();
    }, 1000),
    onChangeTariffLine: function (val) {
      if (this.selectedTariffLine === val) {
        return;
      }
      this.selectedTariffLine = val;
      if (this.selectedTariffLine === 'Receipt') {
        this.kktCount = 1;
      }
      this.calcPrice();
    },
    onChangeTariffPlan: function (tariffPlan) {
      if (this.activeTariffPlanByLineMnemo[this.selectedTariffLine].mnemo === tariffPlan.mnemo) {
        return;
      }
      this.activeTariffPlanByLineMnemo[this.selectedTariffLine] = tariffPlan;
      this.calcPrice();
    },
    onChangeInn: debounce(function () {
      this.innInvalid = false;
      this.innErrors = [];

      if (validateInn(this.Inn, {}) && this.Inn.length === 12) {
        this.isIndividualEntrepreneur = true;
      } else {
        this.isIndividualEntrepreneur = false;
      }

      this.dadataRes = null;
      if (!this.Inn || this.Inn.length < 8) {
        return;
      }
      axios
        .post('/suggestions/api/4_1/rs/suggest/party', {
          query: this.Inn,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        })
        .then((res) => {
          this.dadataRes = res.data.suggestions;
          if (res.data.suggestions && res.data.suggestions.length > 0) {
            this.OrgName = res.data.suggestions[0].data.name.full_with_opf;
            this.Kpp = res.data.suggestions[0].data.kpp;
            this.Ogrn = res.data.suggestions[0].data.ogrn;
            this.innInvalid = false;
            this.innErrors = [];
          } else if (res.data.suggestions && res.data.suggestions.length === 0) {
            this.innInvalid = true;
            this.apiErrHandler('Неправильный ИНН');
            this.innErrors = ['Неправильный ИНН'];
          }
        });
    }, 1000),
    // onInputTariffCount: debounce(function () {
    //   this.calcPrice();
    // }, 1000),
    onInputSmsAddon: debounce(function () {
      this.calcPrice();
    }),
    calcPrice: function () {
      if (this.kktCount && this.selectedTariffLine && this.activeTariffPlanByLineMnemo[this.selectedTariffLine].unitsCnt) {
        this.priceInProgress = true;
        const params = {
          KktCount: this.kktCount,
          FnType: this.fnType,
          // TariffType: this.finallTariffType(this.selectedTariffLine),
          TariffType: this.activeTariffPlanByLineMnemo[this.selectedTariffLine].mnemo,
          // TariffCount: '50',
          // SmsCount: this.SmsCountMore ? this.SmsCountMore : this.SmsCount,
          // BrandingCount: this.BrandingCount,
        };

        if (this.priceAxiosAbortController) {
          this.priceAxiosAbortController.abort();
          this.priceAxiosAbortController = null;
        }

        this.priceAxiosAbortController = new AbortController();

        axios
          .get('/api/calculator/rsb/ferma/price', {
            params,
            signal: this.priceAxiosAbortController.signal,
          })
          .then((res) => {
            this.totalPrice = res.data.Data.TotalPrice || 0;
            // теперь эти данные берём из статик файла
            // this.activeTariffPlanByLineMnemo[this.selectedTariffLine].price = res.data.Data.Calculation[0].Price;
            // this.activeTariffPlanByLineMnemo[this.selectedTariffLine].pricePerUnit =
            //   res.data.Data.Calculation[0].Price / this.activeTariffPlanByLineMnemo[this.selectedTariffLine].unitsCnt;

            this.priceAxiosAbortController = null;
          })
          .catch((err) => {
            this.apiErrHandler(err);
          })
          .finally(() => {
            this.priceInProgress = false;
          });
      } else {
        this.totalPrice = 0;
      }
    },
    onPay: function (e) {
      e.preventDefault();

      if (this.$refs.form_pay.validate()) {
        this.payInProgress = true;

        const params = {
          KktCount: this.kktCount,
          FnType: this.fnType,
          TariffType: this.activeTariffPlanByLineMnemo[this.selectedTariffLine].mnemo,
          TariffCount: '50',
          SmsCount: this.SmsCount,
          BrandingCount: this.BrandingCount,
          Email: this.Email,
          Inn: this.Inn,
          Kpp: this.Kpp,
          Ogrn: this.Ogrn,
          OrgName: this.OrgName,
          PaymentMethod: this.paymentType,
        };

        axios
          .post('/api/order/v1/rsb/ferma/order', params)
          .then((res) => {
            if (res && res.data && res.data.Errors && res.data.Errors.length) {
              this.apiErrHandler(res.data.Errors[0]);
              return;
            }
            this.PaymentInfo = res.data.Data.PaymentInfo;
            this.OrderData = res.data.Data;
            if (this.paymentType === 'Bill') {
              this.scene = 'pay_success';
              scrollTo('calc');
            }
            if (this.paymentType === 'CreditCard') {
              if (this.PaymentInfo.Type === 'Sbrf') {
                this.scene = 'Sbrf';
                scrollTo('calc');
              }
            }
            if (this.paymentType === 'SBP') {
              // scrollTo('calc');
              this.modalSBP = true;
              this.QR = this.PaymentInfo;

              window.setInterval(() =>
              {
                axios.get('/api/payment/' + res.data.Data.PaymentInfo.PaymentId)
                  .then((res) => {
                    // console.log(res);
                    this.stepModal = res.data.Data.Status;

                  }, (err) => {
                    console.log(err);
                  });
              }, 6000);
              return false;
            }
          })
          .catch((err) => {
            this.apiErrHandler(err);
          })
          .finally(() => {
            this.payInProgress = false;
          });
      }

    },
    apiErrHandler: function (err) {
      if (axios.isCancel(err)) {
        return;
      }
      if (typeof err === 'string') {
        this.snackbarText = err;
      } else {
        const errors0 = err.response && err.response.data && err.response.data.Errors
          && err.response.data.Errors.length && err.response.data.Errors[0];
        if (errors0 && errors0.Code === 'IncorrectCredentials') {
          this.snackbarText = 'Неверный логин или пароль';
        } else {
          this.snackbarText = errors0 || 'Произошла ошибка';
        }
      }
      this.snackbarOpened = true;
    },
    onSubmit: function (e) {
      e.preventDefault();

      scrollTo('calc');

      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.selectedTariffLine) {
        this.snackbarText = 'Необходимо выбрать тариф';
        this.snackbarOpened = true;
        return;
      }

      if (!this.activeTariffPlanByLineMnemo[this.selectedTariffLine].unitsCnt) {
        this.snackbarText = this.selectedTariffLine === 'Reciept' ? 'Необходимо выбрать количество чеков' : 'Необходимо выбрать срок аренды кассы';
        this.snackbarOpened = true;
        return;
      }

      if (this.$refs.form.validate() && this.totalPrice) {
        this.scene = 'pay';
      }
    },
    login: function (e) {
      e.preventDefault();
      if (this.$refs.form_login.validate()) {
        this.loginInProgress = true;

        if (this.OrderData.RegisterNewAccountStatus === 'Exists') {
          axios
            .get('/api/Authorization/Deauthorize', {})
            .then(() => {
              axios
                .post('/api/Authorization/Authorize', {
                  Login: this.Email,
                  Password: this.Password,
                  V2Auth: true,
                })
                .then(() => {
                  location.href = '//lk.ofd.ru';
                })
                .catch((err) => {
                  this.apiErrHandler(err);
                })
                .finally(() => {
                  this.loginInProgress = false;
                });
            });
        }

        if (this.OrderData.RegisterNewAccountStatus === 'New') {
          axios
            .get('/api/Authorization/Deauthorize', {})
            .then(() => {
              axios
                .post('/api/userAccounts/SubmitAutoCreated', {
                  Login: this.Email,
                  Password: this.Password,
                })
                .then(() => {
                  location.href = '//lk.ofd.ru';
                })
                .catch((err) => {
                  this.apiErrHandler(err);
                })
                .finally(() => {
                  this.loginInProgress = false;
                });
            });
        }
      }
    },
    showCodes: function () {
      this.codesInProgress = true;
      axios
        .get('/api/order/v1/codes', {
          params: {
            OrderId: this.OrderData.Order.Id,
          }
        })
        .then((res) => {
          if (res.data.Data && res.data.Data.length) {
            this.codes = res.data.Data;
            this.codesInProgress = false;
          } else {
            setTimeout(this.showCodes, 5000);
          }
        })
        .catch((err) => {
          this.apiErrHandler(err);
        });
    },
  },
  component() {
    VSlider
  }
}
</script>

<style src="./style/index.scss" scoped lang="scss"/>
